export default "__VITE_ASSET__BhxYhA9g__"